import { ref, useContext } from "@nuxtjs/composition-api";
import useRecaptcha from "../composables/useRecaptcha";
function useForm(options) {
  const defaultOptions = { captcha: true, confirm: true };
  const mergedOptions = { ...defaultOptions, ...options };
  const { $axios } = useContext();
  const recaptcha = useRecaptcha();
  const formSuccess = ref(false);
  const formPending = ref(false);
  const isConfirmed = ref(false);
  const submit = async (formData, formId = "") => {
    formPending.value = true;
    try {
      const token = recaptcha.getToken();
      const headers = mergedOptions.captcha ? { "Captcha-Token": token } : {};
      const response = await $axios.post(`/api/forms/${formId}`, formData, {
        headers
      });
      formSuccess.value = true;
      return response;
    } finally {
      recaptcha.reset();
      formPending.value = false;
    }
  };
  const isSubmitDisabled = (isFormInvalid) => {
    return isFormInvalid || formPending.value || mergedOptions.captcha && !recaptcha.getToken() || mergedOptions.confirm && !isConfirmed.value;
  };
  return {
    formSuccess,
    formPending,
    submit,
    recaptcha,
    isSubmitDisabled,
    confirm: isConfirmed,
    isConfirmed
  };
}
export {
  useForm as default
};
